// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a5pk","fullView":"styles_fullView__2JVhc"};